<template>
  <div class="full-width justify-center d-flex align-center" style="background-color: #ebebeb; position:relative;">
    <div class="width-register-landing">
      <v-snackbar class="pa-0" style="z-index:1000 !important;top:7%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
        <v-alert
          v-model="alertShow"
          dismissible
          :icon="alertSuccess ? 'mdi-check-circle-outline' : 'mdi-close'"
          class="mb-0 pa-1"
          :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
          light
          close-icon="mdi-close"
        >
          {{ alertMessage }}
        </v-alert>
      </v-snackbar>
      <app-dialog :dialogShow="pageDialogShow" :max-width="400" :title="pageDialog.title" :closeAction="this.pageDialog.dialogXButton">
        <app-page-dialog
          :dialogMessageTitle="pageDialog.messageTitle"
          :dialogMessage="pageDialog.message"
          :dialogButton="pageDialog.button"
          :dialog-attachments="pageDialog.attachment"
        ></app-page-dialog>
      </app-dialog>
      <!-- REGISTER SUCCESS DIALOG -->
      <app-dialog
        :dialogShow="registerSuccessDialogShow"
        :isRegSuccess="true"
        ref="registerSuccessDialog"
        :max-width="400"
        :title="$t(`label.registerSuccess`)"
        :closeAction="this.closeRegisterSuccessDialog"
      >
        <app-register-success :closeRegisterSuccessDialog="closeRegisterSuccessDialog"></app-register-success>
      </app-dialog>
      <v-btn icon class="back-button-register-landing" @click="backToHome()">
        <v-icon class="black--text">mdi-arrow-left</v-icon>
      </v-btn>
      <v-row class="d-flex justify-space-around pb-6 pt-6">
        <router-link :to="{ name: ROUTE_NAME.HOME }" class="d-flex justify-center align-center">
          <img :src="`/static/image/layout/download-app.png`" width="150" height="150" alt="bhaggo logo" style="border-radius: 25%" />
        </router-link>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <h2 class="pt-2 mb-0 justify-center align-center d-flex">
            <label class="black--text">{{ $t(`label.register`) }}</label>
          </h2>
        </v-col>
      </v-row>
      <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'px-2' : 'px-5'">
        <v-window v-model="step">
          <v-window-item :value="0">
            <v-form ref="registerForm1">
              <v-card-text class="ma-0 pa-0">
                <app-form-field
                  ref="username"
                  class="black--text"
                  :enabledLabel="true"
                  v-model.trim="registerObj.memberCode"
                  :label="$t(`field.username`)"
                  :placeholder="$t(`fieldHint.fillUpHere`)"
                  :tooltip="$t(`fieldHint.username`)"
                  :errorMsg="userNameErrorMsg"
                  :blur="checkUsername"
                  :rules="validator.usernameRules(registerObj.password)"
                ></app-form-field>
                <app-form-field
                  :enabledLabel="true"
                  class="black--text"
                  v-model.trim="registerObj.password"
                  :label="$t(`field.password`)"
                  :placeholder="$t(`fieldHint.fillUpPwdHere`)"
                  :tooltip="$t(`fieldHint.password`)"
                  :rules="validator.passwordRules(registerObj.memberCode)"
                  :allowShowPassword="true"
                  type="password"
                  ref="regPassword"
                ></app-form-field>
                <app-form-field
                  :enabledLabel="true"
                  class="black--text"
                  v-model.trim="confirmedPassword"
                  :label="$t(`field.confirmPassword`)"
                  :placeholder="$t(`fieldHint.confirmPassword`)"
                  :rules="validator.confirmPasswordRules(confirmedPassword, registerObj.password)"
                  :allowShowPassword="true"
                  type="password"
                ></app-form-field>
                <app-form-field
                  :enabledLabel="true"
                  class="black--text"
                  :label="$t(`field.currency`)"
                  v-model.trim="registerObj.currency"
                  :disabled="currencyList.length == 1"
                  type="select"
                  :rules="validator.dropDownListRules()"
                  :items="currencyList"
                ></app-form-field>
                <!-- <v-select elevation="2" class="input-field mr-2" item-text="text" item-value="value" :items="mobileNumberPrefixList" dense outlined></v-select> -->
                <app-form-field
                  v-model.trim="registerObj.currency"
                  :placeholder="mobileNumberPrefixList[0].text"
                  type="select"
                  class="black--text"
                  :rules="validator.dropDownListRules()"
                  :items="mobileNumberPrefixList"
                  :display-text="this.getMobileNumberDisplayText"
                  :disabled="mobileNumberPrefixList.length == 1"
                  :custom-class="' reg-mobile-prefix'"
                ></app-form-field>
                <app-form-field
                  :enabledLabel="false"
                  class="black--text"
                  v-model.trim="registerObj.mobileNumber"
                  :placeholder="$t(`fieldHint.fillUpHere`)"
                  :rules="validator.mobileNumberRules(defaultLanguage)"
                ></app-form-field>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-checkbox class="mt-0 pt-0 register-landing-check-box">
                      <template v-slot:label>
                        <p class="caption pt-2 mb-0">
                          <label class="black--text">{{ $t(`message.registerDisclaimer_1`) }}</label>
                          <label class="text-decoration-underline black--text font-weight-bold" style="cursor:pointer" @click="openRegisterTncDialog">{{ $t(`message.registerDisclaimer_2`) }}</label>
                        </p>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
              <Captcha ref="captchaCode" :class="'register-captcha black--text'" v-model.trim="captcha" :isOptional="false" :errorMsg="captchaErrorMsg" :rules="validator.captchaRules()"></Captcha>
              <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-center align-center">
                  <app-button class="dialog-button" :action="this.register" :title="$t(`button.register`)"></app-button>
                </v-col>
                <v-col cols="12" class="text-center">
                  <label v-show="registerErrorMsg" class="red--text subtitle-2">{{ registerErrorMsg }}</label>
                  <label v-show="errorMsg" class="red--text subtitle-2">{{ errorMsg }}</label>
                </v-col>
              </v-row>
              <v-row no-gutters class="d-none">
                <v-col cols="12">
                  <app-button class="dialog-button" :action="this.nextPage" :title="$t(`button.next`)"></app-button>
                  <!-- <v-btn height="auto" @click="step++" color="black" depressed class="primary-button theme-button text-capitalize pa-3 font-weight-bold yellow--text subtitle-1">{{ $t(`button.next`) }}
                  </v-btn> -->
                </v-col>
              </v-row>
            </v-form>
          </v-window-item>
          <v-window-item :value="1">
            <v-form ref="registerForm2">
              <v-card-text class="ma-0 pa-0 d-none">
                <label class="input-field-label ma-0 text-capitalize d-block" :class="$vuetify.breakpoint.mdAndDown ? 'pb-1' : 'pb-2'">
                  {{ $t(`field.phoneNumber`) }}
                  <span class="red--text ml-1">*</span>
                </label>
                <v-row no-gutters>
                  <v-col cols="5">
                    <!-- <v-select elevation="2" class="input-field mr-2" item-text="text" item-value="value" :items="mobileNumberPrefixList" dense outlined></v-select> -->
                    <app-form-field
                      v-model.trim="registerObj.currency"
                      :placeholder="mobileNumberPrefixList[0].text"
                      type="select"
                      :rules="validator.dropDownListRules()"
                      :items="mobileNumberPrefixList"
                      :display-text="this.getMobileNumberDisplayText"
                      :disabled="mobileNumberPrefixList.length == 1"
                      :custom-class="'mr-2 reg-mobile-prefix'"
                    ></app-form-field>
                  </v-col>
                  <v-col cols="7">
                    <app-form-field
                      :enabledLabel="false"
                      v-model.trim="registerObj.mobileNumber"
                      :placeholder="$t(`fieldHint.fillUpHere`)"
                      :rules="validator.mobileNumberRules(defaultLanguage)"
                    ></app-form-field>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="space-between">
                  <v-col cols="4" md="3">
                    <label class="input-field-label ma-0 text-capitalize d-block" :class="$vuetify.breakpoint.mdAndDown ? 'pb-1' : 'pb-2'">
                      {{ $t(`field.otpNo`) }}
                      <span class="red--text ml-1">*</span>
                    </label>
                  </v-col>
                  <v-col cols="8" md="9" class="text-right">
                    <v-btn
                      :v-show="smsRequestAvailable && smsVerificationSent"
                      text
                      height="auto"
                      @click="requestSmsVerificationCode"
                      class="text-capitalize pr-0 font-weight-bold title_color2--text"
                      :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-2'"
                    >
                      {{ $t(`button.notReceivedOtp`) }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="5" class="pr-2">
                    <v-btn
                      height="auto"
                      :disabled="smsVerificationSent && !smsVerificationResult"
                      @click="this.requestSmsVerificationCode"
                      color="black"
                      depressed
                      class="otp-button theme-button font-weight-bold yellow--text"
                    >
                      {{ $t(`button.requestOtp`) }}
                    </v-btn>
                  </v-col>
                  <v-col cols="7">
                    <app-form-field :enabledLabel="false" v-model.trim="registerObj.verificationCode" :placeholder="$t(`fieldHint.fillUpHere`)" :rules="validator.requiredRules()"></app-form-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <app-form-field
                      :enabledLabel="true"
                      v-model.trim="registerObj.referralCode"
                      :label="$t(`field.referralCode`)"
                      :placeholder="$t(`fieldHint.optional`)"
                      :rules="validator.referralCodeRules()"
                      :readonly="isReferralCodeReadonly"
                      :isOptional="true"
                    ></app-form-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-checkbox class="mt-0 pt-0">
                      <template v-slot:label>
                        <p class="caption pt-2 mb-0">
                          <label>{{ $t(`message.registerDisclaimer_1`) }}</label>
                          <label class="text-decoration-underline font-weight-bold" style="cursor:pointer" @click="openRegisterTncDialog">{{ $t(`message.registerDisclaimer_2`) }}</label>
                        </p>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <app-button class="dialog-button" :action="this.register" :title="$t(`button.register`)"></app-button>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <label v-show="registerErrorMsg" class="red--text subtitle-2">{{ registerErrorMsg }}</label>
                    <label v-show="errorMsg" class="red--text subtitle-2">{{ errorMsg }}</label>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-window-item>
          <!-- <v-window-item :value="2">
              <div class="pa-4 text-center">
                  <v-img class="mb-4" contain height="128" src="https://cdn.vuetifyjs.com/images/logos/v.svg"></v-img>
                  <h3 class="text-h6 font-weight-light mb-2">
                      Welcome to Vuetify
                  </h3>
                  <span class="text-caption grey--text">Thanks for signing up!</span>
              </div>
          </v-window-item> -->
          <v-row no-gutters class="d-none">
            <v-col cols="12" class="mt-5">
              <v-item-group v-model="step" class="text-center" mandatory>
                <v-item v-for="n in regSteps" :key="`btn-${n}`">
                  <v-btn
                    color="black"
                    class="ma-2 resgiter-dialog-pagination"
                    active-class="resgiter-dialog-pagination-active"
                    x-small
                    icon
                    :input-value="step == n - 1"
                    @click="onChangePagination(n - 1)"
                  >
                    {{ n }}
                  </v-btn>
                </v-item>
                <v-item v-slot="{ active, toggle }">
                  <v-btn active-class="resgiter-dialog-pagination-active" icon :input-value="active" :disabled="true">
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </v-item>
              </v-item-group>
            </v-col>
          </v-row>
        </v-window>
        <!-- <p class="mt-5 text-center body-1">
                {{ $t(`message.alreadyHaveAccount`) }}
                <v-btn text height="auto" @click="openLogin" class="pa-0 text-uppercase font-weight-bold secondary--text">{{ $t(`label.signIn`) }}
                </v-btn>
            </p> -->
        <div v-if="step == 0" class="d-none">
          <v-row no-gutters class="py-6">
            <v-col cols="12">
              <v-divider class="dialog-divider"></v-divider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <label class="input-field-label ma-0 pb-1 d-block title_color2--text">
                {{ $t(`message.alreadyHaveAccount`) }}
              </label>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-btn height="auto" @click="openLogin" color="black" depressed class="primary-button theme-button text-capitalize pa-2 font-weight-bold yellow--text">
                {{ $t(`button.login`) }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <app-dialog :dialogShow="registerTncDialog.show" :max-width="880" :title="registerTncDialog.title" :closeAction="this.closeRegisterTncDialog">
        <v-container class="fill-height px-6">
          <iframe class="registerTnc-iframe" :src="registerTncUrl" frameborder="0"></iframe>
        </v-container>
        <!-- <app-button :action="this.closeRegisterTncDialog" :title="$t(`label.agree`)"></app-button> -->
      </app-dialog>
    </div>
  </div>
</template>

<script>
import stringFormat from 'string-format'
import { formValidator, uiHelper, locale } from '@/util'
import {
  MEMBER_REGISTER,
  MEMBER_SMS_REQUEST,
  MEMBER_SMS_VERIFY,
  MEMBER_GET_SMS_REQUIREMENT,
  MEMBER_CHECK_USERNAME,
  MEMBER_RESET_CHECK_USERNAME,
  MEMBER_RESET_REGISTER_STORE,
  MEMBER_REGISTER_LOGIN,
  MEMBER_REGISTER_LOGIN_RESET
} from '@/store/member.module'
import { SESSION, SHARED } from '@/constants/constants'
import { errorCodeHelper } from '@/util/error-code-helper'
import { MEMBER_RESET_SMS_VERIFICATION } from '@/store/member.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import language from '@/components/layout/Language.vue'
import AppRegisterSuccess from '@/components/member/registerSuccess.vue'
import { GET_FACEBOOK_PIXEL } from '@/store/facebookpixel.module'
import { GET_TIKTOK_PIXEL } from '@/store/tiktokpixel.module'
import { initTiktokPixels, captureTiktokClickId, getTiktokIdentifiers } from '@/util/tiktok-pixel'
import Captcha from '@/components/Captcha.vue'

export default {
  name: 'appRegister',
  components: { Captcha, AppRegisterSuccess },
  mounted() {
    this.checkAffiliateReferralCode()
    this.checkPhoneVerificationRequirements()
  },
  props: {
    openLoginDialog: {
      type: Function,
      required: true,
      default: () => {}
    },
    allowShowPassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    captcha: '',
    captchaErrorMsg: undefined,
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    registerErrorMsg: '',
    registerSuccessDialogShow: false,
    pageDialogShow: false,
    pageDialog: {
      title: '',
      closePageDialog: () => {},
      messageTitle: '',
      message: [],
      button: []
    },
    defaultLanguage: SHARED.DEFAULT_LANGUAGE,
    registerTncUrl: '',
    registerTncDialog: {
      show: false,
      title: locale.getMessage(`label.registerAccountAgreement`)
    },
    validator: formValidator,
    stringFormat: stringFormat,
    isReferralCodeReadonly: false,
    registerObj: {
      memberCode: '',
      password: '',
      currency: uiHelper.getCurrency(),
      email: '',
      mobileNumber: '',
      verificationCode: '',
      line: '',
      referralCode: '',
      isEarlyBird: '0',
      domain: '',
      language: '',
      platform: '',
      fbPixelId: '',
      fbp: uiHelper.getCookie(SESSION.FB_P),
      fbc: uiHelper.getCookie(SESSION.FB_C),
      ttPixelCode: '',
      ttclid: '',
      ttp: ''
    },
    confirmedPassword: '',
    step: 0,
    regSteps: 2,
    mobileNumberPrefixList: [
      // {
      //     text: "+91",
      //     value: "INR"
      // },
      {
        text: '+880',
        value: 'BDT'
      }
    ],
    currencyList: [
      // 'INR',
      'BDT'
    ],
    errorMsg: undefined,
    userNameErrorMsg: undefined,
    showPassword: false
  }),
  created() {
    this.getFacebookPixels()
    this.getTiktokPixels()
    this.checkReferCode()
  },
  computed: {
    registerLoginComplete() {
      return this.$store.state.member.registerLoginResponse.complete
    },
    facebookPixels() {
      return this.$store.state.facebookPixel.facebookPixels
    },
    tiktokPixels() {
      return this.$store.state.tiktokPixel.tiktokPixels
    },
    registerResponseComplete() {
      return this.$store.state.member.registerResponse.complete
    },
    language() {
      return language
    },
    ROUTE_NAME() {
      return ROUTE_NAME
    },
    smsRequired() {
      return this.$store.state.member.smsVerificationRequired.required
    },
    smsVerificationSent() {
      return this.$store.state.member.smsVerificationSent.success
    },
    smsVerificationResult() {
      return this.$store.state.member.smsVerificationResult.success
    },
    smsVerificationError() {
      return this.$store.state.member.smsVerificationResult.message
    },
    smsRequestError() {
      return this.$store.state.member.smsVerificationSent.message
    },
    smsRequestAvailable() {
      return this.$store.state.member.smsVerificationSent.countDownTimer <= 0
    },
    smsCountdownTimer() {
      return this.$store.state.member.smsVerificationSent.countDownTimer
    },
    checkUsernameResult() {
      return this.$store.state.member.checkUsernameResult.completed
    }
  },
  watch: {
    registerLoginComplete() {
      let response = this.$store.state.member.registerLoginResponse
      if (response.success) {
        console.log('set cookie to true')
        uiHelper.setCookie('popUpSuccessDialog', true)
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.$router.push({
          name: ROUTE_NAME.HOME,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else if (response.code != 0) {
        this.openAlert(response.success, response.error)
        this.$store.dispatch(`${MEMBER_REGISTER_LOGIN_RESET}`)
      }
    },
    facebookPixels: {
      handler(newVal) {
        if (newVal.complete && newVal.success && newVal.data) {
          this.initFacebookPixels(newVal.data)
        }
      },
      immediate: true,
      deep: true
    },
    tiktokPixels: {
      handler(newVal) {
        if (newVal.complete && newVal.success && newVal.data) {
          initTiktokPixels(newVal.data)
        }
      },
      immediate: true,
      deep: true
    },
    registerResponseComplete() {
      let response = this.$store.state.member.registerResponse
      if (response.complete) {
        try {
          this.$ga.event('Account', `Register`, `${response.success ? 'Success' : 'Fail'}${!response.success ? ` [Error : ${response.code}]` : ''}`)
        } catch (err) {
          console.log(err)
        }
        this.registerResponseCompleteDialog(response)
        this.$store.dispatch(`${MEMBER_RESET_REGISTER_STORE}`)
      }
    },
    smsRequestError() {
      if (this.$store.state.member.smsVerificationSent.complete && !this.$store.state.member.smsVerificationSent.success) {
        this.errorMsg = errorCodeHelper.getErrorCodeDesc(this.$store.state.member.smsVerificationSent.code)
      }
    },
    checkUsernameResult() {
      if (this.$store.state.member.checkUsernameResult.completed) {
        if (this.$store.state.member.checkUsernameResult.success) {
          this.userNameErrorMsg = undefined
        } else {
          this.userNameErrorMsg = locale.getMessage(`fieldErrorMessage.usernameUsed`)
        }
        this.$store.dispatch(`${MEMBER_RESET_CHECK_USERNAME}`)
      }
    }
  },
  methods: {
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    initFacebookPixels(pixelData) {
      let noscriptInserted = false

      pixelData.forEach(pixelConfig => {
        const baseDomain = pixelConfig.domain.replace(/^www\./, '')
        const domainRegex = new RegExp(`(^|\\.)?(www\\.)?${baseDomain.replace(/\./g, '\\.')}$`)
        if (domainRegex.test(window.location.hostname)) {
          if (!window.fbq) {
            ;(function(f, b, e, v, n, t, s) {
              if (f.fbq) return
              n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              }
              if (!f._fbq) f._fbq = n
              n.push = n
              n.loaded = true
              n.version = '2.0'
              n.queue = []
              t = b.createElement(e)
              t.async = true
              t.src = v
              s = b.getElementsByTagName(e)[0]
              s.parentNode.insertBefore(t, s)
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
          }

          fbq('init', pixelConfig.fb_pixel_id)
          fbq('track', 'PageView')
          console.log(`FB Pixel loaded: ${pixelConfig.fb_pixel_id} for ${pixelConfig.domain}`)

          // Insert <noscript> only once for the first matching pixel
          if (!noscriptInserted) {
            uiHelper.setCookie(SESSION.FB_PIXEL_CODE, pixelConfig.fb_pixel_id, 30)
            const noscript = document.createElement('noscript')
            noscript.innerHTML = `<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${pixelConfig.fb_pixel_id}&ev=PageView&noscript=1" />`
            document.body.appendChild(noscript)
            noscriptInserted = true
          }
        }
      })
    },
    getFacebookPixels() {
      this.$store.dispatch(GET_FACEBOOK_PIXEL)
    },
    getTiktokPixels() {
      this.$store.dispatch(GET_TIKTOK_PIXEL)
    },
    closeDialog() {
      this.pageDialogShow = false
    },
    backToHome() {
      this.$router.push({
        name: ROUTE_NAME.HOME
      })
    },
    closeRegisterSuccessDialog() {
      this.registerSuccessDialogShow = false
    },
    registerResponseCompleteDialog(response) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.${response.action}`)
      if (response.code != 0 && !response.success) {
        dialog.message.push(errorCodeHelper.getErrorCodeDesc(response.code))
        dialog.button.push({
          title: locale.getMessage(`label.close`),
          action: this.closeDialog
        })
        this.pageDialog.dialogXButton = this.closeDialog()
        this.openPageDialog(dialog)
        this.registerErrorMsg = errorCodeHelper.getErrorCodeDesc(response.code)
      } else {
        this.registerSuccessDialogShow = true
        let vm = this
        setTimeout(function() {
          this.registerSuccessDialogShow = false
          vm.$router.push({
            name: ROUTE_NAME.HOME
          })
        }, 5000)
      }
    },
    checkReferCode() {
      // this.clearAFCookiesByDomains();
      let af = this.$route.query.af
      let r = this.$route.query.refer_code
      let u_s = this.$route.query.utm_source
      let u_m = this.$route.query.utm_medium
      let u_c = this.$route.query.utm_campaign
      let s2 = this.$route.query.s2
      let pid = this.$route.query.sub1
      let refid = this.$route.query.ref_id
      let fbPixelId = this.$route.query.fbPixelId
      try {
        let old_af = uiHelper.getCookie(SESSION.AFF_CODE)
        if (typeof old_af != 'undefined' && old_af != '' && old_af != null) {
          if (old_af !== af) {
            //if old af not match clear all pixel info.
            uiHelper.removeCookie(SESSION.PID)
            uiHelper.removeCookie(SESSION.CLICKID)
            uiHelper.removeCookie(SESSION.UTM_SOURCE)
            uiHelper.removeCookie(SESSION.UTM_MEDIUM)
            uiHelper.removeCookie(SESSION.UTM_CAMPAIGN)
            uiHelper.removeCookie(SESSION.UTM_S2)
          }
        }
      } catch (err) {
        console.log(err)
      }

      var domain = window.location.hostname
      var wwwDomain = domain.replace(/^www\./, '') // Remove "www." if it exists

      // Create a dictionary to map domains to expiration days
      var expirationDaysByDomain = {
        //first array = third party aff / second = agent code
        'krikya.com': [30, 30],
        'krikya.app': [30, 30],
        'krikya88.com': [30, 365],
        'krikya11.net': [30, 30],
        'krikya.pro': [30, 30],
        'krikya.club': [30, 30],
        'krikya.co': [30, 30],
        'krikya.group': [30, 30],
        'krikya22.com': [30, 30],
        'krikya44.com': [30, 30],
        'krikya55.com': [30, 30],
        'krikya66.com': [30, 30],
        'krikya77.com': [30, 365]
        // Add more domains and expiration days as needed
      }

      // Set the expiration day based on the domain
      var expirationDaysArray = expirationDaysByDomain[wwwDomain]

      // Default expiration (e.g., 1 day) if the domain is not in the dictionary or the array is not valid
      var expirationDaysThirdParty = 1
      var expirationDaysAgent = 365

      if (expirationDaysArray && expirationDaysArray.length === 2) {
        // Your logic to choose between short and long expiration here
        // For example, you can check some condition to decide:
        expirationDaysThirdParty = expirationDaysArray[0] // Use short expiration
        expirationDaysAgent = expirationDaysArray[1]
      }
      //PID at here set to utm_source
      if (typeof pid != 'undefined' && pid != '' && pid != null) {
        uiHelper.setCookie(SESSION.PID, pid, expirationDaysThirdParty)
      }
      //REFID at here set to utm_s2
      if (typeof refid != 'undefined' && refid != '' && refid != null) {
        uiHelper.setCookie(SESSION.CLICKID, refid, expirationDaysThirdParty)
      }
      if (typeof u_s != 'undefined' && u_s != '' && u_s != null) {
        uiHelper.setCookie(SESSION.UTM_SOURCE, u_s, expirationDaysThirdParty)
      }
      if (typeof u_m != 'undefined' && u_m != '' && u_m != null) {
        uiHelper.setCookie(SESSION.UTM_MEDIUM, u_m, expirationDaysThirdParty)
      }
      if (typeof u_c != 'undefined' && u_c != '' && u_c != null) {
        uiHelper.setCookie(SESSION.UTM_CAMPAIGN, u_c, expirationDaysThirdParty)
      }
      if (typeof s2 != 'undefined' && s2 != '' && s2 != null) {
        uiHelper.setCookie(SESSION.UTM_S2, s2, expirationDaysThirdParty)
      }
      if (typeof fbPixelId != 'undefined' && fbPixelId != '' && fbPixelId != null) {
        uiHelper.setCookie(SESSION.FB_PIXEL_CODE, fbPixelId, expirationDaysAgent)
      }
      captureTiktokClickId(this.$route.query)
      if (typeof af != 'undefined' && af != '' && af != null) {
        uiHelper.setCookie(SESSION.AFF_CODE, af, expirationDaysAgent)
        this.openRegisterDialog()
      } else {
        if (typeof r != 'undefined' && r != '' && r != null) {
          uiHelper.setCookie(SESSION.REFER_CODE, r, expirationDaysAgent)
          this.openRegisterDialog()
        }
      }
    },
    checkUsername() {
      let registerObj = this.registerObj
      this.$store.dispatch(`${MEMBER_CHECK_USERNAME}`, {
        registerObj
      })
      this.$refs.regPassword.validate()
    },
    onChangePagination(page) {
      if (page == 1) {
        if (this.$refs.registerForm1.validate()) {
          this.step = page
        }
      } else {
        this.step = page
      }
    },
    getMobileNumberDisplayText(data) {
      return data.text
    },
    errorDialog(errorCode) {
      let dialog = this.initializePageDialogProperty()
      dialog.title = locale.getMessage(`label.register`)
      dialog.dialogXButton = null
      dialog.message.push(errorCodeHelper.getErrorCodeDesc(errorCode))
      dialog.button.push({
        title: locale.getMessage(`label.close`),
        action: () => this.closePageDialog()
      })
      this.openPageDialog(dialog)
    },
    openPageDialog(dialog) {
      this.$eventHub.$emit('open-page-dialog', dialog)
    },
    closePageDialog() {
      this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      this.$eventHub.$emit('close-page-dialog', true)
    },
    initializePageDialogProperty() {
      let initPageDialog = {
        title: locale.getMessage(`label.system`),
        dialogXButton: this.closePageDialog,
        messageTitle: '',
        message: [],
        button: []
      }
      return initPageDialog
    },
    checkPhoneVerificationRequirements() {
      this.$store.dispatch(`${MEMBER_GET_SMS_REQUIREMENT}`)
    },
    openRegisterTncDialog() {
      this.registerTncUrl = `${process.env.BASE_URL}static/html/other/${uiHelper.getLanguage()}/register-tnc.html`
      this.registerTncDialog.show = true
      this.registerTncDialog.dialogXButton = this.closePromotionTncDialog
    },
    closeRegisterTncDialog() {
      this.registerTncDialog.show = false
    },
    openLogin() {
      this.$refs.registerForm1.reset()
      if (this.$refs.registerForm2) this.$refs.registerForm2.reset()
      this.openLoginDialog()
    },
    register() {
      // if (this.smsRequired && !this.smsVerificationSent && !this.smsVerificationResult.success) {
      //     this.requestSmsVerificationCode()
      //     return
      // }
      if (this.captcha != null && this.$refs.registerForm1.validate()) {
        //this.registerObj.currency = uiHelper.getCurrency()
        this.registerObj.platform = uiHelper.getPlatform()
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        this.registerObj.fbPixelId = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
        this.registerObj.fbp = uiHelper.getCookie(SESSION.FB_P)
        this.registerObj.fbc = uiHelper.getCookie(SESSION.FB_C)
        Object.assign(this.registerObj, getTiktokIdentifiers())
        this.registerObj.captchaId = this.$refs.captchaCode.$refs.code.id
        this.registerObj.captchaCode = this.captcha
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_REGISTER_LOGIN}`, {
          registerObj
        })
        this.$store.dispatch(`${MEMBER_RESET_SMS_VERIFICATION}`)
      }
    },
    requestSmsVerificationCode() {
      this.$store.state.member.smsVerificationSent.success = false
      if (this.registerObj.mobileNumber) {
        this.registerObj.domain = uiHelper.getHostname()
        this.registerObj.language = uiHelper.getLanguage()
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_REQUEST}`, {
          registerObj
        })
      }
    },
    async verifySmsCode() {
      if (this.$refs.registerForm.validate()) {
        let registerObj = this.registerObj
        this.$store.dispatch(`${MEMBER_SMS_VERIFY}`, {
          registerObj
        })
      }
    },
    checkAffiliateReferralCode() {
      let affilaiteCode = uiHelper.getCookie(SESSION.REFER_CODE)
      if (affilaiteCode != null && affilaiteCode != '') {
        this.registerObj.referralCode = affilaiteCode
        this.isReferralCodeReadonly = true
      } else {
        let affiliateDomain = SHARED.AFFILIATE_DOMAIN.find(x => x.domain.toLowerCase() == window.location.host.toLowerCase())
        if (affiliateDomain != null && affiliateDomain != undefined) {
          this.registerObj.referralCode = affiliateDomain.affiliateCode
          this.isReferralCodeReadonly = true
        } else {
          this.registerObj.referralCode = ''
          this.isReferralCodeReadonly = false
        }
      }
    },
    nextPage() {
      if (this.$refs.registerForm1.validate() && !this.userNameErrorMsg) this.step++
    }
  }
}
</script>

<style lang="scss">
.back-button-register-landing {
  position: absolute;
  top: 2%;
  left: 3%;
}
.width-register-landing {
  width: 80%;
}
.register-landing-check-box .mdi-checkbox-blank-outline {
  color: black;
}
.register-captcha .captcha-code .captcha {
  background-color: #959595;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.register-captcha .captcha-code .refresh {
  background-color: #959595;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.otp-button {
  color: black;
  border-radius: 10px;
  width: 100%;
  font-size: 14px !important;
  padding: 9px !important;
  text-transform: capitalize;
}

.registerTnc-iframe {
  width: 100%;
  height: 500px;
}

.sms-confirm-button.col {
  padding-left: 1em;

  button {
    margin-top: 0 !important;
    height: 50px !important;
  }
}

.resgiter-dialog-pagination {
  background-color: #acacac;
  color: #ffffff !important;
}

.resgiter-dialog-pagination-active {
  background-color: #fddd04;
}

.resgiter-dialog-pagination.theme--light.v-btn.v-btn--disabled {
  color: #ffffff !important;
}

@media (max-width: 959px) {
  .otp-button {
    //width: 102 !important;
    height: 35px !important;
    font-size: 13px !important;
    padding: 10px !important;
  }
}

@media (max-width: 599px) {
  .otp-button {
    //width: fit-content !important;
    height: 35px !important;
    font-size: 13px !important;
    padding: 11px !important;
  }
}

@media (max-width: 425px) {
  .otp-button {
    //width: fit-content !important;
    height: 35px !important;
    font-size: 13px !important;
    padding: 7px !important;
  }
}

@media (max-width: 375px) {
  .otp-button {
    //width: fit-content !important;
    height: 35px !important;
    font-size: 11px !important;
    padding: 4px !important;
  }
  .reg-mobile-prefix.v-input {
    font-size: 12px !important;

    .v-select__selection--comma {
      margin: 7px 0px 7px 0px !important;
    }

    .v-input__icon {
      height: 14px !important;
      width: 14px !important;
      min-width: 14px !important;
    }
  }
}
</style>